export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const UPDATE_SUPPLIER = "UPDATE_SUPPLIER";
export const UPDATE_GROUP = "UPDATE_GROUP";
export const FETCH__LOCATION_IN_BASKET = "FETCH__LOCATION_IN_BASKET";
export const UPDATE_FARMER = "UPDATE_FARMER";
export const UPDATE_HOOFDGROUP = "UPDATE_HOOFDGROUP";
export const UPDATE_SUBGROUP = "UPDATE_SUBGROUP";
export const UPDATE_SUBPRODUCTS = "UPDATE_SUBPRODUCTS";
export const USED_SEARCH_TERM = "USED_SEARCH_TERM";
export const UPDATE_PRODUCTS = "UPDATE_PRODUCTS";
export const UPDATE_SEARCHTERM = "UPDATE_SEARCHTERM";
export const STORE_URL = "STORE_URL";
export const SHOW_HOOFDGROEP = "SHOW_HOOFDGROEP";
export const SHOW_SUBGROEP = "SHOW_SUBGROEP";
export const SHOW_CATALOGUS = "SHOW_CATALOGUS";
export const CHANGE_DELIVERY_OPTION_BODY = "CHANGE_DELIVERY_OPTION_BODY";
